module.exports = __webpack_public_path__ + "static/testimonial-centricity-logo.e06324ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/testimonials/testimonial-centricity-logo.png
// module id = 1301
// module chunks = 35783957827783